export const FiberQualificationEnum = {

  LengthLossLimit:  [
    { key: 0, value: "test_manual" },
    { key: 1, value: "test_application"}
  ],
  
  FiberType: [
    { key: 0, value: "OM1" },
    { key: 1, value: "OM2" },
    { key: 2, value: "OM3" },
    { key: 3, value: "OM4" },
    { key: 4, value: "OM5" },
    { key: 5, value: "OS1" },
    { key: 6, value: "OS2" }
  ],
  
  SpeedType: [
    { key: 1, value: "Custom" },
    { key: 17, value: "100Mb" },
    { key: 18, value: "1Gb" },
    { key: 19, value: "10Gb" },
    { key: 20, value: "40Gb" },
    { key: 21, value: "100Gb" }
  ],

  TestConfig: [
    { key: 0, value: "2_fibers_pair" },
    { key: 1, value: "1_fiber_loop" },
  ]

};

  


// WEBPACK FOOTER //
// ./src/components/job/newsignaltekqt/fiberqualification/fiberqualificationenums.js